import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./i18n";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Gallery from "./pages/Gallery";
import Downloader from "./pages/Downloader";
import QRCodes from "./pages/QRCodes";
import SharePublic from "./pages/SharePublic";
import AdminTools from "./pages/AdminTools";

function App() {
    return (
        <div className="App">
            <LangProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <Toaster
                            position="top-center"
                            theme="dark"
                            toastOptions={{
                                style: {
                                    background: "#121212",
                                    color: "#f4f4f5",
                                    border: "1px solid #27272a",
                                    borderRadius: 0,
                                    fontFamily: "'Space Grotesk', system-ui, sans-serif",
                                },
                            }}
                        />
                        <Routes>
                            <Route path="/s/:token" element={<SharePublic />} />
                            <Route path="/login" element={<Login />} />
                            <Route
                                element={
                                    <ProtectedRoute>
                                        <Layout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="/galerie" element={<Gallery />} />
                                <Route path="/descarcari" element={<Downloader />} />
                                <Route path="/qr" element={<QRCodes />} />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute adminOnly>
                                            <AdminTools />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>
                            <Route path="/" element={<Navigate to="/galerie" replace />} />
                            <Route path="*" element={<Navigate to="/galerie" replace />} />
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
            </LangProvider>
        </div>
    );
}

export default App;
